/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */

import llama, { Component, EventBus, Router } from 'llama'

import enableHotReload from '@winds-of-legends/wol-app-common/src/front/enableHotReload.js'

import FR_I18N from '../locale/lang_fr.js'

import OnboardingRoutes from './OnboardingRoutes.js'

import OnboardingFace from './face/OnboardingFace.js'

import FacePartBody from './face/FacePartBody.js'
import FacePartContour from './face/FacePartContour.js'
import FacePartEyes from './face/FacePartEyes.js'
import FacePartHair from './face/FacePartHair.js'
import FacePartNoseMouth from './face/FacePartNoseMouth.js'

import OnboardingName from './OnboardingName.js'
import OnboardingRegister from './OnboardingRegister.js'

import FaceConfig from '../common/FaceConfig.js'
import ApiClient from './api-client.js'

// TODO add a mechanic to change language
const i18n = FR_I18N

const eventBus = new EventBus({
  /*
  logger: {
    logFor (x) { return ['on', 'emit', 'before', 'after'].includes(x) },
    log (...m) { return console.log(...m) },
    debug (...m) { return console.debug(...m) },
    warn (...m) { return console.warn(...m) },
    error (...m) { return console.error(...m) },
    trace (...m) { return console.trace(...m) }
  }
  // */
})

new ApiClient(eventBus, `${window.location.protocol}//${window.location.host}`).listen()

FaceConfig.init(eventBus)

const router = llama({
  box: 'app-onboarding',
  context: i18n,
  eventBus,
  routes: {
    [OnboardingRoutes.Root]: {
      onLoad () {
        this.emit(Router.GO, OnboardingRoutes.Face(OnboardingRoutes.Portrait, OnboardingRoutes.Head))
      }
    },
    [OnboardingRoutes.Face()]: {
      sub_box: 'onboarding-part-sub',
      type: OnboardingFace,
      embed: {
        [OnboardingRoutes.Default]: {
          onLoad ({ zoom }) {
            this.emit(Router.GO, OnboardingRoutes.Face(zoom, OnboardingRoutes.Head))
          }
        },
        [OnboardingRoutes.Head]: FacePartContour,
        [OnboardingRoutes.Eyes]: FacePartEyes,
        [OnboardingRoutes.NoseMouth]: FacePartNoseMouth,
        [OnboardingRoutes.Hair]: FacePartHair,
        [OnboardingRoutes.Body]: FacePartBody
      }
    },
    [OnboardingRoutes.Name()]: OnboardingName,
    [OnboardingRoutes.Register()]: OnboardingRegister,
    [Router.NOT_FOUND]: {
      name: Router.NOT_FOUND,
      type: Component,
      html: '404 Page not found'
    }
  }
  // logger: console
})

router.run()
router.route()

// new OnboardingMain({
//   box: 'app-onboarding',
//   context: i18n,
//   eventBus
// }).load()

// FIXME use this fix to bypass error in HMR management
enableHotReload()
